// extracted by mini-css-extract-plugin
export var acitonButtons = "_31-0";
export var additionalIcon = "_31-f";
export var block = "_31-1";
export var blockContent = "_31-7";
export var blockDescription = "_31-8";
export var blockIcon = "_31-9";
export var blockTitle = "_31-6";
export var border = "_31-a";
export var center = "_31-l";
export var edge = "_31-b";
export var edgeLabel = "_31-c";
export var edgePath = "_31-d";
export var error = "_31-e";
export var flowchart = "_31-g";
export var flowchartContent = "_31-h";
export var highlighted = "_31-3";
export var hover = "_31-4";
export var icon = "_31-i";
export var left = "_31-m";
export var navButton = "_31-j";
export var navButtons = "_31-k";
export var right = "_31-n";
export var selected = "_31-2";
export var small = "_31-5";